import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { subscribeUser } from '../../models/subscribe.models';

@Injectable({
  providedIn: 'root'
})
export class SubscribeService {

  constructor(private http: HttpClient) {


   
   }

   subscribe(emailId: string): Promise<any>{

    let subscribeUserEndPoint = "https://api.ewns.in/api/Admin/subscribe";
    const subscriberModel: subscribeUser = {
      email: emailId
    };
    return this.http.post(subscribeUserEndPoint, subscriberModel, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise();
   }

   generateLead(emailId: string): Promise<any>{
    let generateLeadEndPoint = "https://api.ewns.in/api/Admin/Lead";
    const subscriberModel: subscribeUser = {
      email: emailId
    };
    return this.http.post(generateLeadEndPoint, subscriberModel, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise();
   }
}
